import { RoundTables } from "../components/Roundtables"


export default {
	background: "https://assets.swoogo.com/uploads/full/1498700-61aa86ec7df3e.jpg",
	extras: <RoundTables numTables={3} seatsPerTable={8} />,
	links: [
		{
			label: "Session Screen",
			width: "62.2%",
			height: "70.9%",
			left: "18.8%",
			top: "1.9%",
		},
		{
			label: "Product Q&A",
			width: "10.8%",
			height: "18.5%",
			left: "3.9%",
			top: "46.9%",
			CometChatID: "product"
		},
	],
	name: "networking",
}
